import DashboardTablePagination from 'features/dashboard/table/DashboardTablePagination'
import SelectBox from 'components/form/SelectBox'
import ColumnSelect from 'features/dashboard/table/config/ColumnSelect'
import OnOffButtons from 'features/dashboard/operation/onOff/OnOffButtons'
import DeleteButton from 'features/dashboard/operation/delete/DeleteButton'
import { useDashboardTableSelector } from 'features/dashboard/utils/hooks/useDashboardTableSelector'
import { useDispatch } from 'react-redux'
import { showCampaignConversionTrackingEdit } from 'features/dashboard/operation/campaignConversionTrackingEdit/campaignConversionTrackingEditSlice'
import { hasTalkChannelCampaign } from 'features/dashboard/operation/campaignConversionTrackingEdit/campaignConversionTrackingEditUtils'
import { showCampaignTraceUrlEdit } from 'features/dashboard/operation/campaignTraceUrlEdit/campaignTraceUrlEditSlice'
import { showCampaignDailyBudgetEdit } from 'features/dashboard/operation/campaignDailyBudgetEdit/campaignDailyBudgetEditSlice'
import CreateCampaignButton from 'features/dashboard/operation/createCampaign/CreateCampaignButton'
import DownloadButton from 'features/dashboard/operation/download/DownloadButton'

const CampaignTableHeader = () => {
  const dispatch = useDispatch()
  const { content, selectedIds } = useDashboardTableSelector()
  const nonSelected = selectedIds.length < 1

  return (
    <div className="set_head">
      <div className="f_left">
        <div className="single_wrap">
          <CreateCampaignButton />
        </div>
        <div className="single_wrap">
          <OnOffButtons />
        </div>
        <div className="single_wrap">
          <SelectBox
            noBlurOnDefault
            className="opt_right"
            placeholder="선택한 캠페인 수정"
            value
            disabled={nonSelected}>
            <SelectBox.Item
              tiaraAction="캠페인탭_전환추적_클릭"
              onClick={() =>
                dispatch(
                  showCampaignConversionTrackingEdit({
                    campaignIds: selectedIds,
                    hasTalkChannel: hasTalkChannelCampaign(
                      content,
                      selectedIds
                    ),
                  })
                )
              }>
              전환추적
            </SelectBox.Item>
            <SelectBox.Item
              tiaraAction="캠페인탭_추적URL_클릭"
              onClick={() => dispatch(showCampaignTraceUrlEdit(selectedIds))}>
              추적URL
            </SelectBox.Item>
            <SelectBox.Item
              tiaraAction="캠페인탭_일예산_클릭"
              onClick={() =>
                dispatch(showCampaignDailyBudgetEdit(selectedIds))
              }>
              일예산
            </SelectBox.Item>
          </SelectBox>
        </div>
        <div className="single_wrap">
          <DeleteButton />
        </div>
      </div>
      <div className="f_right">
        <div className="single_wrap">
          <DashboardTablePagination />
        </div>
        <div className="single_wrap">
          <ColumnSelect />
        </div>
        <div className="single_wrap">
          <DownloadButton />
        </div>
      </div>
    </div>
  )
}
export default CampaignTableHeader
